import { Fragment } from 'react';
import { Avatar, Container, Divider, Stack } from '@optimus-web/core';
import { LocalizedMinorHighlight, LocalizedParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { emailInvitesSent } from '@mews-commander/assets';

interface Props {
    emailsSent: string[];
}

export const AddUsersSuccess = ({ emailsSent }: Props) => (
    <>
        <Container padding={['300', '0']}>
            <Stack vertical itemAlignment="center">
                <img src={emailInvitesSent} alt={TextKey.InvitesSent} width="80" />
                <LocalizedMinorHighlight textKey={TextKey.InvitesSent} align="center" />
                <LocalizedParagraph textKey={TextKey.InvitesSentHint} align="center" variant="secondary" />
            </Stack>
        </Container>
        <Stack vertical spacing="100">
            <Divider />
            {emailsSent.map((email) => (
                <Fragment key={email}>
                    <Stack spacing="100" itemAlignment="center">
                        <Avatar src="" title={email} size="medium" />
                        <span>{email}</span>
                    </Stack>
                    <Divider />
                </Fragment>
            ))}
        </Stack>
    </>
);
